import type { IDeparture } from '../../../../models/departure.model';
import { DepartureApiModel } from './departure.api-model';

export class DepartureResultApiModel {
  public static mapToBusinessModel(apiModel: DepartureResultApiModel): IDeparture[] {
    return apiModel.results.map(DepartureApiModel.mapToBusinessModel);
  }

  public results!: DepartureApiModel[];
}
